import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ColorLogo from "../assets/login/ColorLogo.png";
import logo1 from "../assets/header/HABD.png";
import logo2 from "../assets/login/DMW_Patiala.png";
import logo3 from "../assets/login/NoviusLogo.png";

// Utility to strip HTML tags
const stripHtml = (html) => {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

const DownloadSiteData = async (
  selectedSites,
  sites,
  trainData,
  fromDate,
  toDate,
  setLoading,
  triggerNotification
) => {
  try {
    setLoading(true);

    if (!selectedSites.length || !trainData.length) {
      throw new Error("No sites or train data selected for export");
    }

    const user = JSON.parse(localStorage.getItem("user"));
    const userName = user?.username || "Guest";

    const downloadDate = new Date();

    // ✅ Manually format date and time separately
    const formattedDateTime = `${downloadDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })} ${downloadDate.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })}`;

    const doc = new jsPDF({ orientation: "landscape" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const logoWidth = 18;
    const logoHeight = 15;

    const addHeader = () => {
      doc.setTextColor(0, 0, 0);
      if (ColorLogo) {
        const logoX = 10;
        const logoY = 5;
        const logoW = 35;
        doc.addImage(ColorLogo, "PNG", logoX, logoY, logoW, logoHeight);
        doc.link(logoX, logoY, logoW, logoHeight, {
          url: "https://noviusrailtech.com/",
        });
      }

      if (logo2) {
        doc.addImage(logo2, "PNG", pageWidth - logoWidth - 10, 5, logoWidth, logoHeight);
      }

      const titleText = "NOVIUS HABD (Lite) - NOVIUS HOT AXLE BOX DETECTION SYSTEM (LITE MODEL)";
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");

      const textWidth = doc.getTextWidth(titleText);
      const centerX = pageWidth / 2;
      const offsetX = 20;
      const textX = centerX - textWidth / 2 + offsetX;

      if (logo1) {
        const logo1X = textX - logoWidth - 4;
        doc.addImage(logo1, "PNG", logo1X, 5, logoWidth, logoHeight);
      }

      doc.text(titleText, textX, 15);
      doc.setDrawColor(200, 200, 200);
      doc.line(10, 22, pageWidth - 10, 22);
    };

    const addFooter = () => {
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");

        const pageStr = `Page ${i} of ${pageCount}`;
        doc.text(pageStr, pageWidth - 14 - doc.getTextWidth(pageStr), pageHeight - 10);

        doc.setTextColor(80);
        doc.setFont("helvetica", "italic");
        const footerText = `Downloaded by: ${userName} | Download Time: ${formattedDateTime}`;
        doc.text(footerText, 14, pageHeight - 10);
      }
    };

    const addWatermark = () => {
      if (logo3) {
        const watermarkWidth = 150;
        const watermarkHeight = 100;
        const watermarkX = (pageWidth - watermarkWidth) / 2;
        const watermarkY = (pageHeight - watermarkHeight) / 2;

        doc.saveGraphicsState();
        doc.setGState(new doc.GState({ opacity: 0.08 })); // Reduced opacity
        doc.addImage(logo3, "PNG", watermarkX, watermarkY, watermarkWidth, watermarkHeight);
        doc.restoreGraphicsState();
      }
    };

    addHeader(); // Only once

    // Define table columns
    const columns = [
      "Sr. No.",
      "Status",
      "Site Name",
      "Date & Time",
      "Direction",
      "Train Type",
      "Max Axle Temp (°C)",
      "Avg Axle Temp (°C)",
      "Ambient Temp (°C)",
      "Max Wheel Temp (°C)",
      "Avg Wheel Temp (°C)",
      "Axles",
      "Speed (km/h)",
    ];

    const formatDate = (dateStr) => {
      const date = new Date(dateStr);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    };

    const formattedFromDate = fromDate ? formatDate(fromDate) : "N/A";
    const formattedToDate = toDate ? formatDate(toDate) : "N/A";

    const body = trainData.map((train, index) => [
      index + 1,
      train.status.charAt(0).toUpperCase() + train.status.slice(1),
      train.siteName || "N/A",
      stripHtml(train.dateTime || "N/A"),
      train.direction || "N/A",
      train.trainType || "N/A",
      train.maxAxleTemp !== "N/A" ? `${train.maxAxleTemp} °C` : "N/A",
      train.avgAxleTemp !== "N/A" ? `${train.avgAxleTemp} °C` : "N/A",
      train.ambientTemp !== "N/A" ? `${train.ambientTemp} °C` : "N/A",
      train.maxWheelTemp !== "N/A" ? `${train.maxWheelTemp} °C` : "N/A",
      train.avgWheelTemp !== "N/A" ? `${train.avgWheelTemp} °C` : "N/A",
      train.axles || "N/A",
      train.speed !== "N/A" ? `${train.speed} km/h` : "N/A",
    ]);

    let isFirstPage = true;

    autoTable(doc, {
      startY: 60,
      head: [columns],
      body,
      theme: "grid",
      styles: {
        fontSize: 9,
        cellPadding: 2,
        textColor: [0, 0, 0],
        fillColor: [255, 255, 255],
        halign: "center",
        valign: "middle",
        overflow: "linebreak",
      },
      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        fontSize: 9,
      },
      useCss: true,
      margin: { top: 30, left: 10, right: 10 },
      pageBreak: "auto",
      didDrawPage: () => {
        if (!isFirstPage) {
          addHeader();
        }

        if (isFirstPage) {
          const metaY = 30;
          doc.setFontSize(12);
          doc.setFont("helvetica", "bold");
          doc.text(`Sites: ${selectedSites.join(", ") || "N/A"}`, 14, metaY);
          doc.text(`Date Range: ${formattedFromDate} to ${formattedToDate}`, 14, metaY + 10);
          doc.text("Train Overview", 14, metaY + 20);
        }

        addWatermark(); // ✅ Always add watermark after page content
        isFirstPage = false;
      },
    });

    addFooter();

    const pdfFileName = `Site_Overview_${selectedSites.join("_")}_${fromDate}_to_${toDate}.pdf`;
    doc.save(pdfFileName);
    triggerNotification("PDF generated successfully", "success");
  } catch (error) {
    console.error("Error generating PDF:", error);
    triggerNotification(`Failed to generate PDF: ${error.message}`, "error");
  } finally {
    setLoading(false);
  }
};

export default DownloadSiteData;
